/**
 * UTM Product Injector
 * Captura ?utm_content=<handle> y persiste en localStorage una LISTA de productos
 * UTM (cada uno con su target = handle de la colección donde se capturó).
 *
 * Estructura en localStorage (key "scuffers_utm_product"):
 *   { items: [ { handle, target, expiry }, ... ] }   (newest first)
 *
 * Comportamiento:
 *  - Si la URL trae ?utm_content=<handle>, se añade a la lista; si la URL es
 *    /collections/<X>, target=<X>, si no target=null
 *  - Dedupe por (handle+target): si llega un par repetido, refresca expiry
 *  - Cap a MAX_ITEMS (5): al exceder, descarta el más antiguo (FIFO)
 *  - Featured-collection (data-utm-inject="true"): inyecta TODOS los handles
 *    como primeras cards (newest primero)
 *  - Collection-filter: inyecta solo los handles cuyo target == colección actual
 *
 * KILL SWITCH para A/B test (Varify u otra herramienta):
 *  Por defecto la inyección está DESACTIVADA (control). Se activa si:
 *    A) Flag JS:   window.scuffersUtmInject = { enabled: true };
 *       Sirve para activar en la página actual; se pierde al navegar.
 *    B) Cookie:    scuffers_utm_inject=true
 *       Persiste entre páginas. Caso típico: Varify solo dispara en la landing
 *       (e.g. /collections/best-sellers?utm_content=...) y debe activar la
 *       inyección también en home, otras colecciones, etc. La cookie sobrevive
 *       a la navegación sin que Varify tenga que correr en cada página.
 *  Si nada de esto está, el usuario cae en control. La captura URL→localStorage
 *  SÍ ocurre siempre, así no se pierden datos.
 */
(function() {
  var STORAGE_KEY = 'scuffers_utm_product';
  var INJECT_COOKIE = 'scuffers_utm_inject';
  var TTL_DAYS = 7;
  var MAX_ITEMS = 5;

  function readCookie(name) {
    if (typeof document === 'undefined' || !document.cookie) return null;
    var parts = document.cookie.split(';');
    for (var i = 0; i < parts.length; i++) {
      var p = parts[i].trim();
      if (p.indexOf(name + '=') === 0) return p.substring(name.length + 1);
    }
    return null;
  }

  /* Debug mode via URL param: ?utm_debug=true fuerza la inyección sin Varify ni
     cookie. Se persiste en sessionStorage para que sobreviva navegación interna
     mientras la pestaña esté abierta. Quitar con ?utm_debug=off (o cierra la
     pestaña). */
  function isDebugMode() {
    try {
      var params = new URLSearchParams(window.location.search);
      var p = (params.get('utm_debug') || '').toLowerCase();
      if (p === 'true' || p === '1' || p === 'on') {
        sessionStorage.setItem('scuffers_utm_debug', '1');
        console.log('[UTM debug] ON via URL param. Forzando inyección.');
        return true;
      }
      if (p === 'false' || p === '0' || p === 'off') {
        sessionStorage.removeItem('scuffers_utm_debug');
        console.log('[UTM debug] OFF via URL param.');
        return false;
      }
      return sessionStorage.getItem('scuffers_utm_debug') === '1';
    } catch(e) { return false; }
  }

  function isInjectionEnabled() {
    if (isDebugMode()) return true;
    if (window.scuffersUtmInject && window.scuffersUtmInject.enabled === true) return true;
    if (readCookie(INJECT_COOKIE) === 'true') return true;
    try { if (sessionStorage.getItem('scuffers_utm_inject') === 'true') return true; } catch(e) {}
    return false;
  }

  function isValidHandle(h) {
    return typeof h === 'string' && h.length > 0 && /^[a-z0-9][a-z0-9\-]*$/i.test(h);
  }

  function getCurrentCollectionHandle() {
    /* Aceptar prefijo de locale opcional (`/es/`, `/en-us/`, etc.) que Shopify
       añade a las URLs en stores con i18n. Sin esto, en /es/collections/X el
       regex no matchea, currentCol queda en null y la inyección se aplica en
       cualquier colección sin gating de target. */
    var m = window.location.pathname.match(/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?collections\/([^\/]+)/i);
    return m ? m[1] : null;
  }

  function readRaw() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch(e) { return null; }
  }

  function writeRaw(items) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ items: items }));
    } catch(e) {}
  }

  function clearAll() {
    try { localStorage.removeItem(STORAGE_KEY); } catch(e) {}
  }

  function getStoredItems() {
    var data = readRaw();
    if (!data) return [];
    var items;
    if (Array.isArray(data.items)) {
      items = data.items;
    } else if (isValidHandle(data.handle)) {
      /* Migración de cookie legacy {handle, target, expiry} */
      items = [{ handle: data.handle, target: data.target || null, expiry: data.expiry }];
    } else {
      clearAll();
      return [];
    }
    var now = Date.now();
    var clean = items.filter(function(it) {
      return it && isValidHandle(it.handle) && (!it.expiry || it.expiry > now);
    });
    if (clean.length === 0) {
      clearAll();
    } else if (clean.length !== items.length || !Array.isArray(data.items)) {
      writeRaw(clean);
    }
    return clean;
  }

  function addItem(handle, target) {
    if (!isValidHandle(handle)) return;
    target = target || null;
    var items = getStoredItems().filter(function(it) {
      return !(it.handle === handle && it.target === target);
    });
    items.unshift({
      handle: handle,
      target: target,
      expiry: Date.now() + (TTL_DAYS * 24 * 60 * 60 * 1000)
    });
    if (items.length > MAX_ITEMS) items = items.slice(0, MAX_ITEMS);
    writeRaw(items);
  }

  /* Lee/guarda la posición persistente de un item (handle + target). Permite
     que al volver atrás (back) o navegar entre páginas, la card UTM aparezca
     en la misma posición y no salte aleatoriamente. */
  function getItemPosition(handle, target) {
    target = target || null;
    var items = getStoredItems();
    var found = null;
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      if (it.handle === handle && (it.target || null) === target) { found = it; break; }
    }
    if (!found || typeof found.position !== 'number') return null;
    return found.position;
  }
  function setItemPosition(handle, target, position) {
    target = target || null;
    var items = getStoredItems();
    var changed = false;
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      if (it.handle === handle && (it.target || null) === target) {
        if (it.position !== position) { it.position = position; changed = true; }
      }
    }
    if (changed) writeRaw(items);
  }

  /* Si target === undefined → quita todos los items con ese handle (cualquier target).
     Si target es null o string → quita solo el par (handle, target) exacto. */
  function removeItem(handle, target) {
    var items = getStoredItems();
    var filtered;
    if (typeof target === 'undefined') {
      filtered = items.filter(function(it) { return it.handle !== handle; });
    } else {
      filtered = items.filter(function(it) {
        return !(it.handle === handle && it.target === target);
      });
    }
    if (filtered.length === 0) {
      clearAll();
    } else if (filtered.length !== items.length) {
      writeRaw(filtered);
    }
  }

  function getEffectiveItems() {
    var url = new URLSearchParams(window.location.search);
    var fromUrl = url.get('utm_content');
    if (fromUrl && isValidHandle(fromUrl)) {
      addItem(fromUrl, getCurrentCollectionHandle());
    }
    return getStoredItems();
  }

  function getEffectiveHandles() {
    return getEffectiveItems().map(function(it) { return it.handle; });
  }

  function getHandlesForCollection(currentHandle) {
    if (!currentHandle) return [];
    return getEffectiveItems()
      .filter(function(it) { return it.target === currentHandle; })
      .map(function(it) { return it.handle; });
  }

  function inheritLayoutClasses(card, grid) {
    var firstCard = grid.querySelector('.product-block');
    if (!firstCard) return;
    var keywords = ['half', 'third', 'quarter', 'quintin'];
    Array.from(firstCard.classList).forEach(function(c) {
      if (c.indexOf('column') === 0 || c.indexOf('dynamic-col') === 0 || keywords.indexOf(c) !== -1) {
        card.classList.add(c);
      }
    });
  }

  /* Detecta si estamos en home (raíz o /<locale>/), donde queremos inyectar las
     recently-viewed que no estén en el grid. En el resto solo reordenamos. */
  function isHomePage() {
    return /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?$/i.test(window.location.pathname);
  }

  /* Reordena los productos del grid que existen en localStorage.recentlyViewedProducts,
     poniéndolos justo después de las cards UTM inyectadas (anchorCard = última UTM,
     skipCards = todas las UTM para no moverlas). Si una recently-viewed card no está
     ya en el grid, se ignora — no añadimos cards externas, solo reordenamos las
     existentes. Devuelve la última card movida (o anchorCard si no hubo). */
  function reorderRecentlyViewed(grid, anchorCard, skipCards) {
    if (!grid || !anchorCard) return anchorCard;
    var recent = [];
    try { recent = JSON.parse(localStorage.getItem('recentlyViewedProducts')) || []; } catch(e) {}
    if (!recent.length) return anchorCard;
    var skip = skipCards || [anchorCard];
    var after = anchorCard;
    /* localStorage tiene los más recientes al final del array → reverse para
       que el primero (más reciente) quede al principio del bloque reordenado. */
    recent.slice().reverse().forEach(function(item) {
      if (!item.id) return;
      var c = grid.querySelector('[data-product-id="' + item.id + '"]');
      if (c && skip.indexOf(c) === -1) {
        c.classList.add('producto-recently');
        after.after(c);
        after = c;
      }
    });
    return after;
  }

  /* Como reorderRecentlyViewed pero, si la card no existe en el grid, la fetchea
     vía sections rendering API y la inserta justo después de anchorCard. Cap en
     `cap` cards (default 3) para no saturar el grid de home. Por cada card nueva
     elimina la última del grid para mantener el conteo. Devuelve Promise<lastCard>. */
  function injectRecentlyViewedCards(grid, anchorCard, skipCards, cap) {
    if (!grid || !anchorCard) return Promise.resolve(anchorCard);
    cap = cap || 3;
    var recent = [];
    try { recent = JSON.parse(localStorage.getItem('recentlyViewedProducts')) || []; } catch(e) {}
    if (!recent.length) return Promise.resolve(anchorCard);
    var skip = skipCards || [anchorCard];
    var after = anchorCard;
    var inserted = 0;
    var chain = Promise.resolve();
    recent.slice().reverse().forEach(function(item) {
      chain = chain.then(function() {
        if (inserted >= cap) return;
        if (!item.id || !item.handle) return;
        var existing = grid.querySelector('[data-product-id="' + item.id + '"]');
        if (existing) {
          if (skip.indexOf(existing) === -1) {
            existing.classList.add('producto-recently');
            after.after(existing);
            after = existing;
          }
          return;
        }
        return fetchProductCard(item.handle).then(function(card) {
          if (!card) return;
          if (grid.querySelector('[data-product-handle="' + item.handle + '"]')) return;
          inheritLayoutClasses(card, grid);
          card.classList.add('producto-recently');
          var allCards = Array.from(grid.querySelectorAll('.product-block'));
          var last = allCards[allCards.length - 1];
          if (last && skip.indexOf(last) === -1) last.remove();
          after.after(card);
          after = card;
          inserted++;
        });
      });
    });
    return chain.then(function() { return after; });
  }

  /* Wrapper: en home inyecta cards faltantes; en colección/PDP solo reordena.
     Siempre devuelve Promise. */
  function applyRecentlyViewed(grid, anchorCard, skipCards) {
    if (isHomePage()) {
      return injectRecentlyViewedCards(grid, anchorCard, skipCards, 3);
    }
    return Promise.resolve(reorderRecentlyViewed(grid, anchorCard, skipCards));
  }

  /* Fetch del HTML de la card UTM. Devuelve el .product-block parseado o null.
     Limpia la cookie si el producto no existe / no devuelve card válida. */
  function fetchProductCard(handle) {
    if (!handle) return Promise.resolve(null);
    return fetch('/products/' + encodeURIComponent(handle) + '?sections=utm-product-card')
      .then(function(r) {
        if (!r.ok) { removeItem(handle); return null; }
        return r.json();
      })
      .then(function(data) {
        if (!data) return null;
        var html = data['utm-product-card'];
        if (!html || !html.trim()) { removeItem(handle); return null; }
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var card = doc.querySelector('.product-block');
        if (!card || !card.getAttribute('data-product-handle') || card.getAttribute('data-product-handle') !== handle) {
          removeItem(handle);
          return null;
        }
        return card;
      })
      .catch(function() { return null; });
  }

  /* Marca la card UTM con la clase 'producto-recomendado' (idempotente).
     Se aplica tanto a cards nuevas fetcheadas como a las que ya existían en
     el grid antes de ser identificadas como UTM. */
  function markAsRecommended(card) {
    if (card && !card.classList.contains('producto-recomendado')) {
      card.classList.add('producto-recomendado');
    }
  }

  /* Coloca `card` en posición aleatoria 1-indexed dentro del rango por
     dispositivo (mobile: 4-8, desktop: 5-10). Si ya hay una posición
     guardada en localStorage para este (handle, target), la reutiliza —
     así al volver atrás la card queda en el mismo sitio que antes. */
  function placeCardRandomPosition(grid, card) {
    markAsRecommended(card);
    var cardsList = Array.from(grid.querySelectorAll('.product-block')).filter(function(c) { return c !== card; });
    var isMobile = typeof window !== 'undefined' && window.innerWidth < 768;
    var MIN_POS = isMobile ? 4 : 5;
    var MAX_POS = isMobile ? 8 : 10;
    var minIdx = MIN_POS - 1;
    var maxIdx = Math.min(MAX_POS - 1, cardsList.length);

    var handle = card.getAttribute('data-product-handle');
    var target = getCurrentCollectionHandle();
    var saved = handle ? getItemPosition(handle, target) : null;

    var finalPos, refNode, usedSaved = false;
    if (saved && saved >= MIN_POS && saved <= MAX_POS && cardsList.length >= saved - 1) {
      /* Usar posición guardada */
      var savedIdx = saved - 1;
      refNode = cardsList[savedIdx] || null;
      if (refNode) grid.insertBefore(card, refNode);
      else grid.appendChild(card);
      finalPos = savedIdx + 1;
      usedSaved = true;
    } else if (maxIdx < minIdx) {
      /* Grid demasiado pequeño para el rango — al final */
      grid.appendChild(card);
      finalPos = cardsList.length + 1;
    } else {
      var idx = minIdx + Math.floor(Math.random() * (maxIdx - minIdx + 1));
      refNode = cardsList[idx] || null;
      if (refNode) grid.insertBefore(card, refNode);
      else grid.appendChild(card);
      finalPos = idx + 1;
    }

    /* Persistir la posición para próximas visitas */
    if (handle && !usedSaved) setItemPosition(handle, target, finalPos);

    console.log('[UTM injection]',
      'handle:', handle,
      'gridSize:', cardsList.length + 1,
      'finalPosition:', finalPos,
      'usedSaved:', usedSaved,
      'device:', isMobile ? 'mobile' : 'desktop',
      'range:', MIN_POS + '-' + MAX_POS,
      'gridSelector:', grid.tagName + (grid.id ? '#' + grid.id : '') + (grid.className ? '.' + grid.className.split(' ').slice(0,3).join('.') : ''));
  }

  /* Inserta una card NUEVA en un grid: hereda layout, deduplica, elimina la
     última para mantener conteo, y la coloca en posición aleatoria 5-10. */
  function insertCardIntoGrid(grid, card, handle) {
    inheritLayoutClasses(card, grid);
    var dup = grid.querySelector('[data-product-handle="' + handle + '"]');
    if (dup) dup.remove();
    var allCards = Array.from(grid.querySelectorAll('.product-block'));
    var last = allCards[allCards.length - 1];
    if (last) last.remove();
    placeCardRandomPosition(grid, card);
    return card;
  }

  /* Detecta si un producto es de scope just-women según el tag exacto 'just women'
     (misma convención que el filtro JW del theme en collection-filter.liquid). */
  function isWomanCard(card) {
    if (!card) return false;
    var tags = (card.getAttribute('data-tags') || '').toLowerCase();
    return tags.split(',').map(function(s) { return s.trim(); }).indexOf('just women') !== -1;
  }

  /* Inyecta UN handle en un grid:
     - Si ya está en el grid: lo mueve a posición aleatoria 5-10
     - Si no: fetch + insert en posición 5-10 (eliminando última card para mantener conteo)
     Devuelve la card resultante o null en fallo. */
  function injectOneIntoGrid(grid, handle) {
    if (!isInjectionEnabled()) return Promise.resolve(null);
    if (!grid || !handle) return Promise.resolve(null);
    var existing = grid.querySelector('[data-product-handle="' + handle + '"]');
    if (existing) {
      placeCardRandomPosition(grid, existing);
      return Promise.resolve(existing);
    }
    return fetchProductCard(handle).then(function(card) {
      if (!card) return null;
      return insertCardIntoGrid(grid, card, handle);
    });
  }

  /* Routing por género: dado un par mainGrid/jwGrid, decide a cuál va el handle
     según data-tags del producto. Si la card ya existe en alguno de los grids,
     se usa esa para leer tags sin fetch extra. */
  function injectOneWithGenderRouting(mainGrid, jwGrid, handle) {
    if (!isInjectionEnabled()) return Promise.resolve(null);
    if (!handle || (!mainGrid && !jwGrid)) return Promise.resolve(null);
    var existingMain = mainGrid && mainGrid.querySelector('[data-product-handle="' + handle + '"]');
    var existingJw = jwGrid && jwGrid.querySelector('[data-product-handle="' + handle + '"]');
    var anyExisting = existingMain || existingJw;

    if (anyExisting) {
      var target = isWomanCard(anyExisting) ? jwGrid : mainGrid;
      if (!target) return Promise.resolve(null);
      var existingInTarget = (target === mainGrid) ? existingMain : existingJw;
      if (existingInTarget) {
        placeCardRandomPosition(target, existingInTarget);
        return Promise.resolve(existingInTarget);
      }
      /* Card aparece organicamente en el otro scope. NO movemos (alteraría su
         conteo). Fetch fresco e insertamos en target. */
      return fetchProductCard(handle).then(function(card) {
        if (!card) return null;
        return insertCardIntoGrid(target, card, handle);
      });
    }

    return fetchProductCard(handle).then(function(card) {
      if (!card) return null;
      var t = isWomanCard(card) ? jwGrid : mainGrid;
      if (!t) return null;
      return insertCardIntoGrid(t, card, handle);
    });
  }

  /* Inyecta MÚLTIPLES handles. Itera oldest→newest y prepend, así newest queda
     al frente. Devuelve array de cards insertadas (en orden newest-first). */
  function injectMultipleIntoGrid(grid, handles) {
    if (!isInjectionEnabled()) return Promise.resolve([]);
    if (!grid || !handles || !handles.length) return Promise.resolve([]);
    var reversed = handles.slice().reverse();
    var inserted = [];
    var chain = Promise.resolve();
    reversed.forEach(function(handle) {
      chain = chain.then(function() {
        return injectOneIntoGrid(grid, handle).then(function(card) {
          if (card) inserted.unshift(card);
        });
      });
    });
    return chain.then(function() { return inserted; });
  }

  function applyToAllGrids() {
    /* A/B test (Varify): por defecto NO inyectar. Solo si window.scuffersUtmInject
       .enabled === true (Varify variant treatment) procedemos. La captura URL→
       localStorage SÍ ocurre siempre para no perder datos en bucket control. */
    if (!isInjectionEnabled()) {
      /* Llamamos a getEffectiveItems igual para que la captura del utm_content
         de la URL al localStorage suceda — solo bypassamos la inyección. */
      getEffectiveItems();
      return;
    }
    /* En páginas /collections/<X>, los grids data-utm-inject se filtran por target
       (solo UTMs que apuntan a esta colección). En home/producto/otras, se muestran
       todos los handles guardados.
       Además, fuera de /collections/<X> también inyectamos en grids de collection-filter
       (e.g. el "New Arrivals" del home), porque su inline JS solo corre en filtros AJAX.
       Si la sección tiene dual-scope (main + jw), routeamos cada handle al scope que
       corresponde según data-tags del producto. */
    var currentCol = getCurrentCollectionHandle();
    var handles = currentCol ? getHandlesForCollection(currentCol) : getEffectiveHandles();
    if (!handles.length) return;

    var utmGrids = Array.from(document.querySelectorAll('[data-utm-inject="true"]'));
    var fcGrids = Array.from(document.querySelectorAll('[data-fc-scope] [data-role="products-grid"]'));

    /* Detectar dual-scope (main + jw) */
    function findScopeGrid(scopeName) {
      return fcGrids.find(function(g) {
        var s = g.closest('[data-fc-scope]');
        return s && s.getAttribute('data-fc-scope') === scopeName;
      }) || null;
    }
    var mainScopeGrid = findScopeGrid('main');
    var jwScopeGrid = findScopeGrid('jw');
    var hasDualScope = mainScopeGrid && jwScopeGrid;

    /* Tras inyectar, notificamos a la sección para que reaplique género (galería
       mujer vs hombre) sobre las cards UTM recién insertadas. */
    function notifyInjected() {
      document.dispatchEvent(new CustomEvent('utm:cards:injected'));
    }

    /* Caso 1: hay un grid data-utm-inject explícito → prioridad */
    if (utmGrids.length) {
      var primaryGrid = utmGrids[0];
      injectMultipleIntoGrid(primaryGrid, handles).then(function(insertedCards) {
        var others = utmGrids.concat(fcGrids).filter(function(g) { return g !== primaryGrid; });
        handles.forEach(function(h) {
          others.forEach(function(grid) {
            var dup = grid.querySelector('[data-product-handle="' + h + '"]');
            if (dup && dup !== grid.firstElementChild) dup.remove();
          });
        });
        if (insertedCards && insertedCards.length) {
          var oldestUtm = insertedCards[insertedCards.length - 1];
          applyRecentlyViewed(primaryGrid, oldestUtm, insertedCards).then(notifyInjected);
        } else {
          notifyInjected();
        }
      });
      return;
    }

    /* Caso 2: home/no-colección con dual-scope (collection-filter main+jw) →
       routear por género según data-tags. Recorremos en reverse (oldest→newest)
       para que el más reciente quede al frente de su grid. */
    if (!currentCol && hasDualScope) {
      var insertedByGrid = new Map();
      var chain = Promise.resolve();
      handles.slice().reverse().forEach(function(h) {
        chain = chain.then(function() {
          return injectOneWithGenderRouting(mainScopeGrid, jwScopeGrid, h)
            .then(function(card) {
              if (!card) return;
              var g = card.parentElement;
              if (!insertedByGrid.has(g)) insertedByGrid.set(g, []);
              insertedByGrid.get(g).unshift(card);
            });
        });
      });
      chain.then(function() {
        var rvChain = Promise.resolve();
        insertedByGrid.forEach(function(cards, g) {
          if (!cards.length) return;
          rvChain = rvChain.then(function() {
            return applyRecentlyViewed(g, cards[cards.length - 1], cards);
          });
        });
        rvChain.then(notifyInjected);
      });
      return;
    }

    /* Caso 3: home/no-colección con un solo fcGrid visible → inyectar todos ahí */
    var visibleFcGrids = fcGrids.filter(function(grid) {
      var scope = grid.closest('[data-fc-scope]');
      return !scope || scope.style.display !== 'none';
    });
    if (!currentCol && visibleFcGrids.length) {
      var fallbackGrid = visibleFcGrids[0];
      injectMultipleIntoGrid(fallbackGrid, handles).then(function(insertedCards) {
        var others = fcGrids.filter(function(g) { return g !== fallbackGrid; });
        handles.forEach(function(h) {
          others.forEach(function(grid) {
            var dup = grid.querySelector('[data-product-handle="' + h + '"]');
            if (dup && dup !== grid.firstElementChild) dup.remove();
          });
        });
        if (insertedCards && insertedCards.length) {
          var oldestUtm = insertedCards[insertedCards.length - 1];
          applyRecentlyViewed(fallbackGrid, oldestUtm, insertedCards).then(notifyInjected);
        } else {
          notifyInjected();
        }
      });
    }
  }

  /* API pública para que collection-filter (u otras secciones AJAX) integren. */
  window.scuffersUtmInjector = {
    apply: applyToAllGrids,
    getHandle: function() { var h = getEffectiveHandles(); return h.length ? h[0] : null; },
    getHandles: getEffectiveHandles,
    getHandlesForCollection: getHandlesForCollection,
    injectOneIntoGrid: injectOneIntoGrid,
    injectMultipleIntoGrid: injectMultipleIntoGrid,
    injectOneWithGenderRouting: injectOneWithGenderRouting,
    inheritLayoutClasses: inheritLayoutClasses,
    fetchProductCard: fetchProductCard,
    isWomanCard: isWomanCard,
    /* True si el producto tiene tag 'just women'. Usa card cacheada en algún
       grid si está disponible para evitar fetch extra. */
    isWomanProduct: function(handle, contextGrids) {
      contextGrids = contextGrids || [];
      for (var i = 0; i < contextGrids.length; i++) {
        if (!contextGrids[i]) continue;
        var c = contextGrids[i].querySelector('[data-product-handle="' + handle + '"]');
        if (c) return Promise.resolve(isWomanCard(c));
      }
      return fetchProductCard(handle).then(function(card) {
        return isWomanCard(card);
      });
    },
    removeItem: removeItem,
    clear: clearAll
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyToAllGrids);
  } else {
    applyToAllGrids();
  }
  document.addEventListener('fc:cards:replaced', applyToAllGrids);
})();
